import React from 'react'
import './CheckWrapper.scss'

export default React.memo(function CheckWrapper(props){
    return <div className='check-wrapper'>{props.children}</div>
})